<template>
  <div
      class="d-flex flex-row align-center"
      :class="{'small-toggle-label': smallLabel}"
  >
    <div>
      <v-label>{{leftLabel}}</v-label>
    </div>
    <v-switch
        v-model="toggle"
        :label="rightLabel"
        hide-details
        class="ml-2 py-2 mt-0"
        @change="onChange"
    />
  </div>
</template>

<script>
export default {
  type: "atom",
  name: "ToggleButton",
  props: {
    value: {
      type: Boolean
    },
    leftLabel: {
      type: String
    },
    rightLabel: {
      type: String
    },
    smallLabel: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      toggle: this.value
    }
  },
  methods: {
    onChange (value) {
      this.$emit("change", value);
    }
  },
  watch: {
    value: {
      handler: function(value) {
        this.toggle = value
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.small-toggle-label >>> * {
  font-size: 14px;
}
</style>